import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "./Text";
const isDefaultCustomLink = (link) => {
    return "linkType" in link.fields && link.fields.linkType === "custom";
};
export const Link = ({ data, options, style }) => {
    const children = data.children?.map((linkChild) => (_jsx(Text, { data: linkChild, options: options }, linkChild.text)));
    return options?.link ? (options.link(data, children)) : isDefaultCustomLink(data) ? (_jsx("a", { href: data.fields.url, target: data.fields.newTab ? "_blank" : undefined, rel: data.fields.newTab ? "noopener noreferrer" : undefined, style: style, children: children })) : undefined;
};
